import type { RouteLocation } from "vue-router";
import { useUser } from "@domain/Security";

/**
 * Controls the display of interrupt pages before allowing the user to access the Safety Center tab
 * @param to 
 * @param from 
 * @returns 
 */
export const SafetyCenterRouteGuard = async ( to: RouteLocation, from: RouteLocation ) =>
{
    const user = useUser();
    if( user.isDealerMode )
    {
        // If we are coming from a previously unauthorized page
        // block navigation to prevent an infinite redirect
        if( from.path.includes('unauthorized') )
        {
            return false;
        }

        return {
            path: '/dealer-mode/unauthorized',
            query: to.query
        }
    }
};